<template>
  <div v-if="bannerConfig">
    <div
      v-if="isMobile && isEN"
      :class="['mobile-discord-banner']"
      :style="{
        backgroundImage: `url(https://static-web.hzmk.site/as/bigo-static/act_30282/jessic/730x210.jpg)`
      }"
      @click="join"
    ></div>

    <div v-else-if="isMobile" :class="['mobile-discord-banner']" @click="join">
      <div class="mid-text">
        <div class="mid-text1">
          {{ bannerConfig.text1 }}
        </div>
        <!-- <div class="mid-text2">
          {{ bannerConfig.text2 }}
        </div> -->
      </div>

      <div class="right-arrow"></div>
    </div>

    <div
      v-else
      :class="[
        'discord-banner',
        {
          'discord-banner-isRoom': isRoom,
          'discord-banner-pointer': isEN
        }
      ]"
      :style="{
        backgroundImage: bgIMG
      }"
      @click="joinFullClick"
    >
      <template v-if="!isEN">
        <div :class="['bigo-logo']"></div>

        <div class="mid-text">
          <div class="mid-text1">
            {{ bannerConfig.text1 }}
          </div>
          <div class="mid-text2">
            {{ bannerConfig.text2 }}
          </div>
        </div>

        <div class="right-btn" @click="join">
          {{ bannerConfig.btnText }}
        </div>
      </template>

      <div class="close-btn" @click.prevent="hideBanner"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  props: {
    isRoom: Boolean,
    isMobile: Boolean
  },
  data() {
    return {
      bannerConfig: null
    };
  },
  computed: {
    isEN() {
      if (this.bannerConfig && this.bannerConfig.isEN) {
        return true;
      }
      return false;
    },
    bgIMG() {
      if (this.isEN) {
        return `url(https://static-web.hzmk.site/as/bigo-static/act_30282/jessic/1340x90.jpg)`;
      }
      return `url(https://static-web.hzmk.site/as/bigo-static/www.bigo.tv/img/${
        this.isRoom ? 'room-' : ''
      }banner-bg.png)`;
    }
  },
  mounted() {
    const baseConfig = {
      // en: {
      //   text1: 'BIGO Live is now on Discord!',
      //   text2:
      //     'Join the server today for the latest news, updates and giveaways. ',
      //   btnText: 'Join',
      //   link: 'https://bigo.onelink.me/1168916328/JeesieJ',
      //   isEN: true,
      //   inRoom: false // 是否在room中展示
      // },
      pl: {
        text1: 'Dołącz do BIGO LIVE jako agent lub broadcaster!',
        text2:
          'Jesteś zainteresowany rozpoczęciem własnej kariery w BIGO? Wypełnij formularz!',
        btnText: 'Aplikuj teraz',
        link: 'https://forms.gle/F2Bw8E7QHALKvCna9',
        inRoom: true
      },
      ro: {
        text1: 'Alăturați-vă BIGO LIVE ca agent sau broadcaster!',
        text2:
          'Ești interesat să îți începi o noua carieră în BIGO? Completază acest formular!',
        btnText: 'Aplică acum',
        link: 'https://forms.gle/cDKPc2Ubit9mftL19',
        inRoom: true
      },
      tr: {
        // TODO
        text1: "Bigo'nun resmi yayıncı/ajansı olmak için fırsatı kaçırmayın!",
        text2:
          'Yeni haberler, güncellemeler ve politikalar için Bigo’ya bugün katılın',
        btnText: 'katıl',
        link:
          'https://docs.google.com/forms/d/e/1FAIpQLSeXk5fk8LzB0FaAp527pyA7FyudGjnICI1YjuTEzyPtZHFlrg/viewform',
        inRoom: true
      },
      fr: {
        text1: 'Bigo recherche de nouveaux broadcasters talentueux!',
        text2: `Vous êtes beau/belle? Vous savez chanter? Vous avez un talent spécial? Venez montrer aux autres et gagner de l'argent.`,
        btnText: 'Inscrire',
        link: 'https://forms.gle/ZYxhDmtKpk91DC578',
        inRoom: true
      },
      th: {
        text1: 'BIGO เปิดรับสมัคร Official Agency',
        text2: `งานชิวทำที่ไหนก็ได้ รายได้สูงสุด "หลักล้าน"!! รีบมาสมัครสังกัดของบีโก้กัน`,
        btnText: 'สมัครทันที',
        link: 'https://forms.gle/dscFTcakovorGPJA8',
        inRoom: true
      },
      it: {
        text1: 'Come diventare Agenti e Broadcaster su BIGO LIVE?',
        text2: `Adesso comincia anche tu a guadagnare soldi e conoscere nuovi amici!`,
        btnText: 'Maggior info',
        link:
          'https://docs.google.com/forms/d/e/1FAIpQLSdiufVUJwQUCdFyGtUPE_IE6P6_PshOsvaJOuUB5w-VwUNgrg/viewform',
        inRoom: true
      },
      id: {
        text1: 'Daftar Agency di BIGO LIVE dan dapatkan banyak keuntungan!',
        text2: `SELAMAT!! Kamu selangkah lebih dekat untuk menjadi Official AGENCY BIGO LIVE`,
        btnText: 'Daftar',
        link: 'https://forms.gle/ihiE9t48Nhvi3NdR7',
        inRoom: true
      }
    };
    this.bannerConfig = baseConfig[this.$i18n.locale];

    // if (this.isRoom) {
    //   if (!this.bannerConfig || !this.bannerConfig.inRoom) {
    //     this.hideBanner();
    //   }
    // }
  },
  methods: {
    hideBanner() {
      this.bannerConfig = null;
    },
    join() {
      window.open(this.bannerConfig.link, '_blank');
    },
    joinFullClick() {
      if (this.isEN) {
        window.open(this.bannerConfig.link, '_blank');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/mixin.scss';

.discord-banner {
  width: 1340px;
  height: 90px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  border-radius: 4px;
  margin-bottom: 48px;
  margin-top: -12px; // 因为上面有padding-top 60px, 60-48 = 12px

  .bigo-logo {
    width: 68px;
    height: 68px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url('~@assets/img/banner/bigo.png');
    margin: 0 28px;

    &.bigo-logo-discord {
      background-image: url('~@assets/img/banner/discord.png');
    }
  }

  .mid-text {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    color: #ffffff;
    flex: 1;

    .mid-text1 {
      font-size: 28px;
      font-weight: bold;
      line-height: 34px;
    }

    .mid-text2 {
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
      margin-top: 3px;
    }
  }

  .right-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 120px;
    padding: 0 10px;
    height: 48px;
    background: #ffffff;
    border-radius: 24px;
    font-size: 24px;
    font-weight: 600;
    color: #2f3033;
    line-height: 28px;
    margin-right: 65px;
    cursor: pointer;
  }

  .close-btn {
    width: 32px;
    height: 32px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url('~@assets/img/banner/close.png');
    position: absolute;
    right: 11px;
    top: 6px;
    cursor: pointer;
  }

  &.discord-banner-isRoom {
    margin-top: 24px;

    .mid-text {
      color: #2f3033;
    }
  }

  &.discord-banner-pointer {
    cursor: pointer;
  }
}

.mobile-discord-banner {
  width: pxTorem(730);
  height: pxTorem(210);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: url('~@assets/img/banner/mobile-bg.png');
  margin: 0 auto;
  padding-left: pxTorem(36);
  padding-right: pxTorem(84);
  padding-top: pxTorem(20);
  position: relative;
  margin-bottom: pxTorem(10);
  overflow: hidden;

  .mid-text {
    .mid-text1 {
      font-size: pxTorem(36);
      font-weight: 800;
      color: #2f3033;
      line-height: pxTorem(44);
      text-align: left;
    }

    .mid-text2 {
      font-size: pxTorem(24);
      font-weight: 500;
      color: #2f3033;
      line-height: pxTorem(29);
      text-align: left;
      margin-top: pxTorem(12);
      // TODO 阿语
    }
  }

  .right-arrow {
    width: pxTorem(131);
    height: pxTorem(28);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url('~@assets/img/banner/right-arrow.png');
    position: absolute;
    bottom: pxTorem(24);
    left: pxTorem(36);
  }
}
</style>
